import { lazy } from "react";
import { Loader } from "../root/loader";
const TenantIntermediarySettings = lazy(() => import("./components/settings/intermediary/index"));

export const tenantSettings = () => [
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: "/tenant/settings/intermediaries",
            element: (
                <Loader>
                    <TenantIntermediarySettings view="DASHBOARD" />
                </Loader>
            )
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: "/tenant/settings/intermediaries/wizard",
            element: (
                <Loader>
                    <TenantIntermediarySettings view="CREATE" />
                </Loader>
            )
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: "/tenant/settings/intermediaries/wizard/:intermediaryTaxId/:step",
            element: (
                <Loader>
                    <TenantIntermediarySettings view="CREATE" />
                </Loader>
            )
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: "/tenant/settings/intermediaries/edit/:intermediaryTaxId",
            element: (
                <Loader>
                    <TenantIntermediarySettings view="EDIT" />
                </Loader>
            )
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: "/tenant/settings/intermediaries/edit/:intermediaryTaxId/:step",
            element: (
                <Loader>
                    <TenantIntermediarySettings view="EDIT" />
                </Loader>
            )
        }
    }
];
